import React from 'react';

export default function(props) {
    return (
        <React.Fragment>
            <h4>
                Что-то пошло не так.
            </h4>
            <div className="row">
                Кажется, при открытии страницы оплаты что-то пошло не так.
                Закройте эту вкладку и попробуйте снова.
            </div>
        </React.Fragment>
    )
}
